import React from 'react';
import "../../style/register.scss";
import DivLanguage from "../../components/DivLanguage";
import AuthForm from "../../components/forms/AuthForm";
import ManualRegisterForm from "../../components/forms/ManualRegisterForm";
import QRcode from "../../components/forms/QRcode";



const RegisterReavie = () => {


    return (
        <>
            <section >
                <div className="center">

                    <DivLanguage language="fr" className="title center">
                        <h1>
                            REAVIE 2026
                        </h1>

                    </DivLanguage>
                    <DivLanguage language="en" className="title center">
                        <h1>
                            REAVIE 2026
                        </h1>

                    </DivLanguage>

                </div>
            </section>

            <section className="center">
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '70vh'}}>
                    <h1>Scannez le QR Code</h1>
                    <QRcode/>
                    <p style={{ marginTop: '20px', textAlign: 'center' }}>
                        Utilisez votre téléphone pour accéder à la page d'enregistrement
                    </p>
                </div>

            </section>



        </>
    )
};

export default RegisterReavie;